// extracted by mini-css-extract-plugin
export default {"loader":"PaymentSummary_loader__TkXNU"};